export default __webpack_public_path__ + "static/media/responsive-resume-template.eda852e6.gif";